import { PillSegmentToggle } from './PillSegmentToggle'

interface Props {
  value: 'week' | 'month'
  onChange: (value: 'week' | 'month') => void
  testId?: string
  variant?: 'metric' | 'chart'
  accentColor?: string
  trackBg?: string
}

const WEEK_MONTH_OPTIONS = [
  { value: 'week' as const, label: 'Week' },
  { value: 'month' as const, label: 'Month' },
]

export function WeekMonthToggle({
  value,
  onChange,
  testId,
  variant = 'chart',
  accentColor,
  trackBg,
}: Props) {
  return (
    <PillSegmentToggle
      value={value}
      onChange={onChange}
      options={WEEK_MONTH_OPTIONS}
      testId={testId}
      variant={variant}
      accentColor={accentColor}
      trackBg={trackBg}
    />
  )
}
